import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  getUserDetailsById,
  getMyTeam,
  getImgSociety
} from '../../../../utils/apiUser';

import {
  sendEditedUserData,
  setEditedProfile,
  setUserProfile
} from '../../../../actions/user';

import {
  ABOUT_YOU,
  SOCIAL,
  HOBBIES,
  LANGUAGE,
  EDUCATION,
  EXPERIENCE,
  MOD_EXPERIENCE_ACTUAL,
  MOD_EXPERIENCE_PAST,
  DELETE_EXPERIENCE_PAST
} from '../../../../constants/modals';
import { DELETE_EXPERIENCE_PAST as DELETE_EXPERIENCE_PAST_LITERAL } from '../../../../constants/literals/modals';
import Profile from '../../../views/Employee/Profile';
import {
  Aboutyou,
  Experience,
  Education,
  Language,
  ModExperienceActual,
  Confirmation,
  Hobbies,
  Social
} from '../../../views/Employee/Edition';

import Loading from '../../../core/Loading';

import { MONTHS } from '../../../../constants/dates';

class ProfileWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      activeModal: null,
      userData: null,
      saveButtonIsActived: false,
      userTeam: [],
      sameUser: true,
      imgSociety: null
    };
  }

  componentDidMount() {
    const { match } = this.props;
    document.body.style.overflow = 'unset';
    this.getData(match.params.id);
  }

  componentWillReceiveProps(nextProps) {
    const { match } = this.props;

    if (nextProps.match.params.id !== match.params.id) {
      this.state = {
        loading: true
      };
      this.getData(nextProps.match.params.id);
    }
  }

  onClickEditIconHandler = (modal = null, draft = null) => {
    let data = {
      activeModal: modal
    };

    if (modal === DELETE_EXPERIENCE_PAST || MOD_EXPERIENCE_PAST) {
      data = { ...data, draftExperience: draft };
    }

    this.setState(data);
  };

  onClickProfileButtonHandler = () => {
    this.onSaveEditedData();
  };

  onCloseModalHandler = () => {
    this.setState({
      activeModal: null,
      draftExperience: null
    });
  };

  onAcceptModalHandler = data => {
    const { setEditedProfileHandler } = this.props;
    const { activeModal } = this.state;
    let key = '';

    switch (activeModal) {
      case ABOUT_YOU:
        key = 'description';
        break;
      case EDUCATION:
        key = 'educations';
        break;
      case LANGUAGE:
        key = 'languages';
        break;
      case HOBBIES:
        key = 'hobbies';
        break;
      case SOCIAL:
        key = 'rrss';
        break;
      default:
        break;
    }

    let { userData } = this.state;
    userData = { ...userData, [key]: data };

    setEditedProfileHandler(true);

    this.setState(
      { activeModal: null, userData, saveButtonIsActived: true },
      () => {
        this.onSaveEditedData();
      }
    );
  };

  onSaveEditedData = () => {
    const { setEditedProfileHandler } = this.props;

    this.createParsedData();

    setEditedProfileHandler(false);

    this.setState({ activeModal: null, saveButtonIsActived: false });
  };

  onAcceptDeleteExperiencePast = () => {
    const { setEditedProfileHandler } = this.props;
    const { draftExperience, userData } = this.state;
    const { pastPositions } = userData;

    setEditedProfileHandler(true);

    this.setState(
      {
        activeModal: null,
        saveButtonIsActived: true,
        userData: {
          ...userData,
          pastPositions: pastPositions.filter(
            item => item.id !== draftExperience.id
          )
        },
        draftExperience: null
      },
      () => {
        this.onSaveEditedData();
      }
    );
  };

  onAcceptModalHandlerExperience = (
    dataCurrentPositions,
    dataPastPositions
  ) => {
    const { setEditedProfileHandler } = this.props;
    let { userData } = this.state;
    userData = {
      ...userData,
      currentPositions: dataCurrentPositions,
      pastPositions: dataPastPositions
    };

    setEditedProfileHandler(true);

    this.setState(
      { activeModal: null, userData, saveButtonIsActived: true },
      () => {
        this.onSaveEditedData();
      }
    );
  };

  /**
   * Get formatted data adding random id and expanded property
   */

  getFormattedData = data =>
    data
      ? data.map(item => {
          if (item.name) {
            return {
              ...item,
              id: `${item.name}${item.certification}`,
              expanded: true
            };
          }
          return {
            ...item,
            id: `${item.title}${item.companyName}`,
            expanded: true
          };
        })
      : [];

  /**
   * Get formatted contact data like the mock user.js
   */

  getFormattedContactData = (userDetail, userProfile) => ({
    ...userProfile,
    extension: userProfile.extension,
    telephone: userProfile.phones,
    mobile: '000 00 00 00',
    address: userProfile.address,
    email: userProfile.email,
    name: userProfile.name,
    lastname: userProfile.lastname,
    publicName: userProfile.publicName,
    ...userDetail.rrss
  });

  getModal = activeModal => {
    const { userData, draftExperience } = this.state;
    const {
      currentPositions,
      description,
      pastPositions,
      rrss,
      languages,
      educations,
      skills
    } = userData;

    const objMonth = MONTHS.map((month, index) => {
      let value = String(index + 1);
      value = value.length === 1 ? `0${value}` : value;
      return { value, text: month };
    });

    const currentDate = new Date();
    const currentMonth =
      currentDate.getMonth() < 10
        ? `0${currentDate.getMonth()}`
        : `${currentDate.getMonth()}`;

    const arrYears = [];
    const minAgeWorker = 18;
    const maxAgeWorker = 67;
    const currentYear = currentDate.getFullYear();
    const currentStrYear = String(currentYear);
    const initYear = currentYear - (maxAgeWorker - minAgeWorker);

    for (let i = currentYear; i >= initYear; i -= 1) {
      arrYears.push({ value: `${i}`, text: `${i}` });
    }

    let modal = null;
    switch (activeModal) {
      case ABOUT_YOU:
        modal = (
          <Aboutyou
            onCloseModal={this.onCloseModalHandler}
            onAcceptModal={this.onAcceptModalHandler}
            dataAboutYou={description}
          />
        );
        break;
      case DELETE_EXPERIENCE_PAST:
        modal = (
          <Confirmation
            onCloseModal={this.onCloseModalHandler}
            onAcceptModal={this.onAcceptDeleteExperiencePast}
            data={DELETE_EXPERIENCE_PAST_LITERAL}
          />
        );
        break;
      case EDUCATION:
        modal = (
          <Education
            dataEducation={educations}
            listMonths={objMonth}
            listYears={arrYears}
            onAcceptModal={this.onAcceptModalHandler}
            onCloseModal={this.onCloseModalHandler}
            selectedMonths={currentMonth}
            selectedYears={currentStrYear}
          />
        );
        break;
      case EXPERIENCE:
        modal = (
          <Experience
            dataCurrentPositions={currentPositions}
            dataPastPositions={pastPositions}
            listMonths={objMonth}
            listYears={arrYears}
            onAcceptModal={this.onAcceptModalHandlerExperience}
            onCloseModal={this.onCloseModalHandler}
          />
        );
        break;
      case LANGUAGE:
        modal = (
          <Language
            dataLanguage={languages}
            listNivel={[
              { value: 'BAJO', text: 'Bajo' },
              { value: 'MEDIO', text: 'Medio' },
              { value: 'ALTO', text: 'Alto' }
            ]}
            onAcceptModal={this.onAcceptModalHandler}
            onCloseModal={this.onCloseModalHandler}
            selectedNivel="MEDIO"
          />
        );
        break;
      case MOD_EXPERIENCE_ACTUAL:
        modal = (
          <ModExperienceActual
            dataCurrentPositions={currentPositions}
            dataPastPositions={pastPositions}
            listMonths={objMonth}
            listYears={arrYears}
            onAcceptModal={this.onAcceptModalHandlerExperience}
            onCloseModal={this.onCloseModalHandler}
          />
        );
        break;
      case MOD_EXPERIENCE_PAST:
        modal = (
          <Experience
            editExperience={draftExperience}
            dataCurrentPositions={currentPositions}
            dataPastPositions={pastPositions}
            listMonths={objMonth}
            listYears={arrYears}
            onAcceptModal={this.onAcceptModalHandlerExperience}
            onCloseModal={this.onCloseModalHandler}
          />
        );
        break;
      case HOBBIES:
        modal = (
          <Hobbies
            dataSkills={skills}
            onCloseModal={this.onCloseModalHandler}
            onAcceptModal={this.onAcceptModalHandler}
          />
        );
        break;
      case SOCIAL:
        modal = (
          <Social
            dataSocial={rrss}
            onCloseModal={this.onCloseModalHandler}
            onAcceptModal={this.onAcceptModalHandler}
          />
        );
        break;
      default:
        modal = null;
        break;
    }

    return modal;
  };

  getImageSociety = idUser => {
    Promise.resolve(getImgSociety(idUser)).then(res => {
      const imgSociety =
        process.env.NODE_ENV === 'production'
          ? `https://intranetapi.atresmedia.com/images${res}`
          : `https://intranetpre.atresmedia.com/images${res}`;
      this.setState({ imgSociety });
    });
  };

  getProfile = () => {
    const { editMode, idUser } = this.props;
    const {
      activeModal,
      userData,
      saveButtonIsActived,
      userTeam,
      sameUser,
      imgSociety
    } = this.state;
    const {
      userContact,
      rrss,
      description,
      languages,
      educations,
      hobbies
    } = userData;

    const getHtmlParsed = data => ({ __html: data });
    return (
      <Fragment>
        {this.getModal(activeModal)}
        <Profile
          idUser={idUser}
          dataLanguage={languages}
          dataHobbies={hobbies}
          dataTeam={userTeam}
          dataEducations={educations}
          dataUser={userContact}
          dataSocial={rrss}
          imgSociety={imgSociety}
          editMode={editMode}
          sameUser={sameUser}
          educationsPublic={userData.educationsPublic}
          languagesPublic={userData.languagesPublic}
          hobbiesPublic={userData.hobbiesPublic}
          saveButtonIsActived={saveButtonIsActived}
          clickProfileButtonsHandler={this.onClickProfileButtonHandler}
          clickEditIconHandler={this.onClickEditIconHandler}
        >
          {(description && description.length) === 11 ? (
            undefined
          ) : (
            // eslint-disable-next-line react/no-danger
            <p dangerouslySetInnerHTML={getHtmlParsed(description)} />
          )}
        </Profile>
      </Fragment>
    );
  };

  getData = id => {
    const { setUserProfileHandler, idUser } = this.props;
    getUserDetailsById(id || idUser)
      .then(userDetails => {
        const { userDetail, userProfile } = userDetails;
        setUserProfileHandler(userProfile);
        this.setState({
          userData: {
            ...userDetail,
            userContact: this.getFormattedContactData(userDetail, userProfile),
            languages: this.getFormattedData(userDetail.languages),
            educations: this.getFormattedData(userDetail.educations),
            currentPositions: this.getFormattedData(
              userDetail.currentPositions
            ),
            imgSociety: this.getImageSociety(idUser),
            pastPositions: this.getFormattedData(userDetail.pastPositions)
          }
        });

        getMyTeam(userProfile.idArea)
          .then(team => {
            this.setState({
              userTeam: team.map(partner => ({
                userId: partner.userId,
                person: `${partner.name} ${partner.lastname}`,
                lastname: partner.lastname,
                job: partner.profile,
                image: partner.pathImage,
                email: partner.email,
                avatarPhoto: partner.avatarPhoto
                  ? partner.avatarPhoto
                  : undefined
              }))
            });
          })
          .catch(error => {
            throw error;
          })
          .finally(() => {
            this.setState({
              loading: false,
              sameUser: Number(id) === idUser
            });
          });
      })
      .catch(error => {
        throw error;
      });
  };

  /**
   * create parsed data (userData cloned and formatted) to send it to BBDD
   */

  createParsedData() {
    const { userData } = this.state;

    this.setState(
      {
        parsedUserData: _.cloneDeep(userData)
      },
      () => {
        this.deleteUserContactProperty();
        this.deleteIdAndExpandedProperty();
        this.sendData();
      }
    );
  }

  deleteUserContactProperty() {
    const { parsedUserData } = this.state;

    delete parsedUserData.userContact;
  }

  deleteIdAndExpandedProperty() {
    const { parsedUserData } = this.state;

    _.forIn(parsedUserData, value => {
      if (_.isArray(value)) {
        _.forEach(value, item => {
          const itm = item;
          delete itm.id;
          delete itm.expanded;
        });
      }
    });
  }

  sendData() {
    const { onSendEditedUserData } = this.props;
    const { parsedUserData } = this.state;

    onSendEditedUserData(parsedUserData);
  }

  render() {
    const { loading } = this.state;

    return loading ? <Loading size="xl" /> : this.getProfile();
  }
}

ProfileWrapper.propTypes = {
  userDetail: PropTypes.shape({
    description: PropTypes.string,
    educations: PropTypes.arrayOf(
      PropTypes.shape({
        degree: PropTypes.string,
        endDate: PropTypes.string,
        schoolName: PropTypes.string,
        startDate: PropTypes.string
      })
    ),
    languages: PropTypes.arrayOf(
      PropTypes.shape({
        certification: PropTypes.string,
        name: PropTypes.string,
        proficiency: PropTypes.string
      })
    ),
    lastModifiedDate: PropTypes.string,
    rrss: PropTypes.shape({
      facebook: PropTypes.string,
      twitter: PropTypes.string,
      linkedin: PropTypes.string,
      instagram: PropTypes.string,
      vimeo: PropTypes.string
    }),
    position: PropTypes.arrayOf(
      PropTypes.shape({
        companyName: PropTypes.string,
        current: PropTypes.bool,
        endDate: PropTypes.string,
        startDate: PropTypes.string,
        summary: PropTypes.string,
        title: PropTypes.string
      })
    )
  }),
  userProfile: PropTypes.shape({
    address: PropTypes.string,
    extension: PropTypes.number,
    email: PropTypes.string,
    employeeId: PropTypes.string,
    idDepartment: PropTypes.number,
    idSubDepartment: PropTypes.number,
    lastname: PropTypes.string,
    location: PropTypes.string,
    name: PropTypes.string,
    profile: PropTypes.string,
    societyId: PropTypes.string,
    typology: PropTypes.string,
    userId: PropTypes.number,
    username: PropTypes.string
  }),
  editMode: PropTypes.bool
};

const mapDispatchToProps = dispatch => ({
  setUserProfileHandler: profile => dispatch(setUserProfile(profile)),
  onSendEditedUserData: data => sendEditedUserData(data),
  setEditedProfileHandler: state => dispatch(setEditedProfile(state))
});

const mapStateToProps = ({ user }) => ({
  username: user.user.username,
  idUser: user.user.userId
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileWrapper);
